exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* line with highlight area */\n.sparkline {\n  stroke: #1a8bdf;\n  fill: #e4f6ff;\n  height: 30px;\n  width: 100px;\n  vertical-align: middle;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/sparkline/sparkline.component.less
// module id = ../../../../../src/app/shared/sparkline/sparkline.component.less
// module chunks = 2